import { forwardRef, useState } from 'react'
import type { ElementRef } from 'react'

import { useRefCallback } from 'hooks/use-ref-callback'

import Box from 'components/atomic/atoms/box'
import Input, { InputProps } from 'components/atomic/atoms/input'
import Text from 'components/atomic/atoms/text'

const NAME = 'InputUrl'

const InputUrl = forwardRef<
  ElementRef<typeof Box>,
  InputProps & { baseUrl: string }
>(({ baseUrl, ...props }, forwardedRef) => {
  const [width, setWidth] = useState(0)
  const ref = useRefCallback<HTMLDivElement>(e => {
    setWidth(e.getBoundingClientRect().width + 12)
  })

  return (
    <Box
      relative
      ref={forwardedRef}
      css={{
        width: '$full',
        '&:focus-within > div': {
          borderColor: '$text4',
        },
      }}
    >
      <Box
        ref={ref}
        absolute
        flex
        items="center"
        css={{
          px: '$3',
          height: '$full',
          color: '$text3',
          borderRight: '1px solid $bg3',
        }}
      >
        <Text size="sm" color="text2">
          {baseUrl}
        </Text>
      </Box>
      <Input
        {...props}
        css={{
          ...props.css,
          pl: width,
        }}
      />
    </Box>
  )
})

InputUrl.displayName = NAME

export default InputUrl
